export const MAGIC_LOGIN_START = "auth/MAGIC_LOGIN_START";
export const MAGIC_LOGIN_REQUESTING_TOKEN = "auth/MAGIC_LOGIN_REQUESTING_TOKEN";
export const MAGIC_LOGIN_RECEIVING_TOKEN = "auth/MAGIC_LOGIN_RECEIVING_TOKEN";

export const magicLoginRequestToken = (
  resourceType: string,
  resourceId: string,
  emailAddress: string
) => ({
  type: MAGIC_LOGIN_REQUESTING_TOKEN,
  payload: { resourceType, resourceId, emailAddress },
});

export const magicLoginReceivingToken = (upn: string, token: string) => ({
  type: MAGIC_LOGIN_RECEIVING_TOKEN,
  payload: { upn, token },
});
